const app = {
    //BASE_URL: 'http://localhost:8005',
    BASE_URL: 'https://desarrolladoras.core-api.constructoramagc.com',
    PREFIX_URL: '/api',
}

export default app;

